"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignedPatientsContext = void 0;
const react_1 = require("react");
exports.AssignedPatientsContext = (0, react_1.createContext)({});
